module.exports = __webpack_public_path__ + "/images/email-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/email-selected.svg
// module id = 618
// module chunks = 0